'use strict';

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

module.exports = function isNaN(value) {
	return value !== value;
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/is-nan/implementation.js